import React, { useEffect, useState } from "react";
import get from "lodash/get";
import { bool, number, string } from "prop-types";
import { connect } from "react-redux";

import { Link } from "@quintype/components";

import { getSponsorObj } from "../../helper/api";
import { staticTexts } from "../../utils/Translate";
import { cancelablePromise, dataAttr } from "../../utils/utils";

import "./sponsorDetails.m.css";

const SponsorDetails = ({ sponsorId, lang, showImage = true, scrollIndex }) => {
  const [sponsors, setSponsors] = useState();

  useEffect(() => {
    const promise = cancelablePromise(getSponsorObj(sponsorId));
    promise.promise
      .then((sponsorObj) => {
        setSponsors(sponsorObj);
      })
      .catch(() => {});

    return () => {
      promise.cancel();
    };
  }, [sponsorId]);

  if (!sponsors) return null;

  const { title, url } = sponsors;
  const sponsorsLogoUrl = sponsors?.photo?.[0]?.url || "";

  const sponsorLayout = (
    <div styleName="sponsor-details" className="sponsor-details-base">
      {showImage && <div styleName="sponsor-logo">{sponsorsLogoUrl && <img src={sponsorsLogoUrl} alt={title} />}</div>}
      <div className={!showImage ? "no-image" : ""} styleName={`${!showImage ? "no-image" : ""}`}>
        <div {...dataAttr(`data-author-${scrollIndex}`, title)} styleName="sponsor-name" className="sponsor-name">
          {title}
        </div>
        <div styleName="sponsor-type" className="sponsor-type">
          {staticTexts(lang).sponsorType}
        </div>
      </div>
    </div>
  );

  return (
    sponsors && (
      <div styleName="base" className="sponsor-details-wrapper">
        {url ? (
          <Link aria-label={title} href={url} target="_blank" rel="noindex nofollow">
            {sponsorLayout}
          </Link>
        ) : (
          sponsorLayout
        )}
      </div>
    )
  );
};

SponsorDetails.propTypes = {
  sponsorId: number,
  lang: string,
  showImage: bool,
  scrollIndex: number,
};

const mapStateToProps = (state) => ({
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], ""),
});

export default connect(mapStateToProps)(SponsorDetails);
